/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/log.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the logarithm of a value to a base. The input can be any numeric value, the return value is always a double.
 *
 * Logs of zero, negative numbers, and base of one return `null` as well as a warning.
 *
 * @example
 * ROW base = 2.0, value = 8.0
 * | EVAL s = LOG(base, value)
 *
 * @example
 * ROW value = 100
 * | EVAL s = LOG(value);
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'log',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: true,
        },
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: true,
        },
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: true,
        },
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'double',
          optional: true,
        },
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: true,
        },
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: true,
        },
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: true,
        },
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'integer',
          optional: true,
        },
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: true,
        },
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: true,
        },
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: true,
        },
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'long',
          optional: true,
        },
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: true,
        },
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: true,
        },
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: true,
        },
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'base',
          type: 'unsigned_long',
          optional: true,
        },
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
